import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import "./BlogCard.css"
import ArrowRight from "../Icons/ArrowRight"

export default function BlogCard({ data }) {
  console.log(data)
  const image = getImage(
    data.featuredImage?.node.localFile.childImageSharp.gatsbyImageData
  )

  return (
    <Link to={data.uri}>
      <div className="vt-blog__card">
        <GatsbyImage image={image} className="vt-blog__card--image" />
        <div className="vt-blog__card--content">
          <h4>{data.title}</h4>
          <p dangerouslySetInnerHTML={{ __html: data.excerpt }}></p>
          <div className="vt-blog-card-read-more">
            <h5>Lees meer</h5>
            <ArrowRight />
          </div>
        </div>
      </div>
    </Link>
  )
}
